import {Component} from 'react';
import {doubleToStringMonthly} from '../../objects/CommonUse/double_functions';
import {reformatDateToDisplay} from '../../objects/CommonUse/reformatDateToDisplay_function';


class ArchiveGameList extends Component {
    constructor(props) {
        super(props);
        this.state = {
          open: false, 
          selected: false};
    }

    render() {
    return <>
        <tr>
            <td className="text-center">{this.props.gameInfo.gameNbr}</td>
            <td className="mx-0">{reformatDateToDisplay(this.props.gameInfo.dateArchived, "YYYY/MM/DD")}</td>
            <td>{doubleToStringMonthly(this.props.gameInfo.gameCashAmt)}</td>
            <td>{this.props.gameInfo.jobChoice}</td>
            <td>{this.props.gameInfo.homeChoice}</td>
            <td>{this.props.gameInfo.carChoice}</td>
        </tr>
   
    </>
    }
}

export default ArchiveGameList;